import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/globel.css'
import 'lib-flexible'

import axios from 'axios'

axios.defaults.baseURL = '/api/'
// axios.defaults.baseURL = 'https://shuimui-szsmjr.com/api/'
axios.defaults.headers.post['Content-type'] = 'multipart/form-data'

// 与线上一致：通过 media query 覆盖根字号（覆盖 lib-flexible）
;(function injectRemMediaQuery() {
  if (document.getElementById('media-query-style')) return
  const style = document.createElement('style')
  style.id = 'media-query-style'
  style.innerHTML = `
    @media only screen and (max-width: 4000px) {
      html { font-size: 12px !important; }
    }
    @media only screen and (max-width: 600px) {
      html { font-size: 9px !important; }
    }
    @media only screen and (max-width: 480px) {
      html { font-size: 9px !important; }
    }
    @media only screen and (max-width: 320px) {
      html { font-size: 6px !important; }
    }
  `
  document.head.appendChild(style)
})()

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$http = axios
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
